module.exports = __webpack_public_path__ + "static/media/red-card.0c22bd55.png";